import { render, staticRenderFns } from "./DocumentsAndDeclarationStep.component.vue?vue&type=template&id=21121fc8&"
import script from "./DocumentsAndDeclarationStep.component.vue?vue&type=script&lang=ts&"
export * from "./DocumentsAndDeclarationStep.component.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsAndDeclarationStep.component.vue?vue&type=style&index=0&id=21121fc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports